import products from '../content/products/products.json'

export default function useProducts(productCategoryId) {
    if (!productCategoryId) {
        return products
    }

    return products.filter((x) => x.categoryId === productCategoryId)
}
